import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Observable, Subject} from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-cancel-warning-modal',
  templateUrl: './warning-modal.component.pug',
  styleUrls: ['./warning-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class WarningModalContentComponent implements OnInit {
  negateResult = false;
  title = $localize`Leave this page?`;
  bannerMessage = $localize`Deleting the API key will immediately disable the ability to view, send and receive updates on all reference requests.`;
  tmpBannerMessage = $localize `Deleting the API key will immediately stop the ability to view and request background checks from Trust Marketplace.`
  message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
  cancelButton = $localize`Cancel`;
  agreeButton = $localize`Yes`;
  deleteButton = $localize`Delete request`
  icon = "https://assets.xref.com/omni/shared/alert_dialog_icon.svg";
  showWarningIcon = true
  addMargin = false
  selection = new Subject<boolean>();
  errorText?: string;
  disableAgree?: Boolean = false;
  onPulseTab: Boolean = false;
  onDeleteModal: Boolean = false;
  isBackgroundCheck:Boolean = false;
  typeModal = '';
  PulseButtonText:string = $localize`Yes, I'm sure`;
  referenceMsg:string = $localize`0 reference request`;
  backgroundCheckMsg:string = $localize`0 background check`;
  referenceWarningMessage = '';
  isDeleteBanner = false;
  isTmpDelete = false;

  constructor(
    private bsModalRef: BsModalRef,
    private el: ElementRef,
    private permissions: PermissionsService
  ) {
  }

  ngOnInit(): void {
    this.configureModal();
    if (this.typeModal === 'background-check') {
      this.isBackgroundCheck = true;
    }
  }

  configureModal() {
      if(this.typeModal==='pulse-delete') {
        this.onPulseTab = true;
        this.onDeleteModal = true
      }
      else if(this.typeModal==='pulse-cancel') {
        this.onDeleteModal = false;
        this.onPulseTab = true;
      }
    }

  getSelectionObservable(): Observable<boolean> {
    return this.selection.asObservable();
  }

  cancel() {
    this.bsModalRef.hide();
    if (this.negateResult) this.selection.next(true);
    else this.selection.next(false);
  }

  agree() {
    this.permissions.setNavCheck(true)
    this.bsModalRef.hide();
    if (this.negateResult) this.selection.next(false);
    else this.selection.next(true);
  }

  close() {
    this.bsModalRef.hide();
    this.selection.next(false);
  }
}
